import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { ApiUrls } from "./ApiUrls";
import { MatSnackBar } from "@angular/material/snack-bar";
import { InstallmentConfigurationInitFormResponseModel } from "../model/InstallmentConfigurationInitFormResponseModel";
import { InstallmentConfigurationLotteryInitFormResponseModel } from "../model/InstallmentConfigurationLotteryInitFormResponseModel";
import { InstallmentConfigurationSchemeInitFormResponseModel } from "../model/InstallmentConfigurationSchemeInitFormResponseModel";
import { LotteryInstallmentConfigurationModel } from "../model/LotteryInstallmentConfigurationModel";
import { SchemeInstallmentConfigurationModel } from "../model/SchemeInstallmentConfigurationModel";
import { TenementInsConfigInitFormResponseModel } from "../model/TenementInsConfigInitFormResponseModel";
import { TenementInsConfigFiltersInitFormResponseModel } from "../model/TenementInsConfigFiltersInitFormResponseModel";
import { TenementInsConfigInitFormModel } from "../model/TenementInsConfigInitFormModel";
import { TenementInsConfigInitModel } from "../model/TenementInsConfigInitModel";
import { TenementInsConfigInitWrapperModel } from "../model/TenementInsConfigInitWrapperModel";
import { TenementInstallmentConfigurationModel } from "../model/TenementInstallmentConfigurationModel";
import { InstallmentConfigurationTenementInitEditFormResponseModel } from "../model/InstallmentConfigurationTenementInitEditFormResponseModel";
import { TenementInsConfigDocumentModel } from "../model/TenementInsConfigDocumentModel";

@Injectable({
  providedIn: "root",
})
export class TenementInstallmentConfigService {
  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) {}

  initTenementInsConfigForm() {
    return this.httpClient.get<TenementInsConfigInitFormResponseModel>(
      ApiUrls.tenementInsConfigInitFormUrl
    );
  }

  initWithLottery(lotteryKey: number) {
    return this.httpClient.get<InstallmentConfigurationLotteryInitFormResponseModel>(
      ApiUrls.installmentConfigInitWithLotteryUrl.replace(
        "{lotteryKey}",
        lotteryKey.toString()
      )
    );
  }
  viewWithLottery(lotteryKey: number, installmentType: string) {
    return this.httpClient.get<InstallmentConfigurationLotteryInitFormResponseModel>(
      ApiUrls.viewinstallmentConfigInitWithLotteryUrl
        .replace("{lotteryKey}", lotteryKey.toString())
        .replace("{installmentType}", installmentType)
    );
  }
  viewWithScheme(
    lotteryKey: number,
    schemeKey: number,
    installmentType: string
  ) {
    return this.httpClient.get<InstallmentConfigurationSchemeInitFormResponseModel>(
      ApiUrls.viewinstallmentConfigInitWithSchemeUrl
        .replace("{lotteryKey}", lotteryKey.toString())
        .replace("{schemeKey}", schemeKey.toString())
        .replace("{installmentType}", installmentType)
    );
  }

  initWithScheme(lotteryKey: number, schemeKey: number) {
    console.log("In Service lottery selected", lotteryKey);
    console.log("In Service scheme selected", schemeKey);

    return this.httpClient.get<TenementInsConfigFiltersInitFormResponseModel>(
      ApiUrls.initWithScheme
        .replace("{lotteryKey}", lotteryKey.toString())
        .replace("{schemeKey}", schemeKey.toString())
    );
  }

  initWithBldg(lotteryKey: number, schemeKey: number, bldg: string) {
    return this.httpClient.get<TenementInsConfigFiltersInitFormResponseModel>(
      ApiUrls.initWithBldg
        .replace("{lotteryKey}", lotteryKey.toString())
        .replace("{schemeKey}", schemeKey.toString())
        .replace("{bldg}", bldg)
    );
  }

  initWithWing(
    lotteryKey: number,
    schemeKey: number,
    bldg: string,
    wing: string
  ) {
    console.log("****>>>>in tenement service", wing);
    return this.httpClient.get<TenementInsConfigFiltersInitFormResponseModel>(
      ApiUrls.initWithWing
        .replace("{lotteryKey}", lotteryKey.toString())
        .replace("{schemeKey}", schemeKey.toString())
        .replace("{bldg}", bldg)
        .replace("{wing}", wing)
    );
  }

  initWithFloor(
    lotteryKey: number,
    schemeKey: number,
    bldg: string,
    wing: string,
    floor: string
  ) {
    return this.httpClient.get<TenementInsConfigFiltersInitFormResponseModel>(
      ApiUrls.initWithFloor
        .replace("{lotteryKey}", lotteryKey.toString())
        .replace("{schemeKey}", schemeKey.toString())
        .replace("{bldg}", bldg)
        .replace("{wing}", wing)
        .replace("{floor}", floor)
    );
  }

  getAllTenementDtls(
    lotteryKey: number,
    schemeKey: number,
    bldg: string,
    wing: string,
    floor: string,
    page: number,
    size: number
  ) {
    let reqParams = new HttpParams()
      .set("lotteryKey", lotteryKey.toString())
      .set("schemeKey", schemeKey.toString())
      .set("bldg", bldg)
      .set("wing", wing)
      .set("floor", floor)
      .set("page", page)
      .set("size", size);
    return this.httpClient.get<TenementInsConfigInitFormModel>(
      ApiUrls.getAllTenementDtls,
      { params: reqParams }
    );
  }

  getConfigOfTenement(tenementKey: number) {
    return this.httpClient.get<TenementInsConfigInitWrapperModel>(
      ApiUrls.getConfigOfTenement.replace("{key}", tenementKey.toString())
    );
  }

  getConfigurationDetailsOfTenement(tenementKey: number) {
    return this.httpClient.get<TenementInsConfigInitWrapperModel>(
      ApiUrls.getConfigurationDetailsOfTenementForEdit.replace(
        "{key}",
        tenementKey.toString()
      )
    );
  }

  saveTenementConfig(data: any) {
    return this.httpClient.post<{
      status: string;
      successMsg: string;
      errorMessage: string;
    }>(ApiUrls.saveTenementConfig, {
      tenementConfigs: data.tenementInstallmentConfigs,
      tenementKeys: data.tenementKeys,
    });
  }

  updateTenementConfig(data: any) {
    console.log("Before Back End Call DATA Check>> ", data);
    return this.httpClient.post<{
      status: string;
      successMsg: string;
      errorMessage: string;
    }>(ApiUrls.updateTenementConfig, {
      tenementConfigs: data.tenementInstallmentConfigs,
      tenementKeys: data.tenementKeys,
      updatedConfigKeys: data.updatedConfigKeys,
    });
  }

  checkConfigOfTenements(tenementKeys: number[]) {
    let reqParam = new HttpParams().set(
      "tenementKeys",
      tenementKeys.toString()
    );
    return this.httpClient.get<TenementInsConfigInitWrapperModel>(
      ApiUrls.checkConfigOfTenements,
      { params: reqParam }
    );
  }

  getDocumentFile(tenementConfigKey: number, tenementKey: number) {
    return this.httpClient.get<TenementInsConfigDocumentModel>(
      ApiUrls.getDocumentFile
        .replace("{tenementConfigKey}", tenementConfigKey.toString())
        .replace("{tenementKey}", tenementKey.toString())
    );
  }

  saveLotteryInstallmentConfiguration(
    lotteryKey: number,
    data: LotteryInstallmentConfigurationModel[]
  ) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      ApiUrls.installmentConfigSaveWithLotteryUrl.replace(
        "{lotteryKey}",
        lotteryKey.toString()
      ),
      {
        lotteryInstallmentConfigs: data,
      }
    );
  }

  saveSchemeInstallmentConfiguration(
    lotteryKey: number,
    schemeKey: number,
    data: SchemeInstallmentConfigurationModel[]
  ) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      ApiUrls.installmentConfigSaveWithSchemeUrl
        .replace("{lotteryKey}", lotteryKey.toString())
        .replace("{schemeKey}", schemeKey.toString()),
      {
        schemeInstallmentConfigs: data,
      }
    );
  }

  async successToast(msg) {
    await this._snackBar.open(msg, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }
}
